import { NextRouter } from 'next/router';
import { TimeRangeSelector } from '@appd/uik/@future';
import { UserInfoPayload } from '../../../../types';
import isValidUserInfo from './isValidUserInfo';
import isValidCurrentTheme from './isValidCurrentTheme';
import isValidTimeRange from './isValidTimeRange';

/**
 * Checks if all pre-initialization conditions for the dashboard viewer are met.
 *
 * @param {NextRouter} router - The Next.js router object.
 * @param {TimeRangeSelector.TimeRange.Resolved} timeRange - The resolved time range.
 * @param {string} currentTheme - The current theme identifier.
 * @param {UserInfoPayload} userInfo - User information.
 * @param {boolean} globalsInitialized - Whether global settings have been initialized.
 * @returns {boolean} True if all conditions are satisfied, false otherwise.
 */
const arePreInitConditionsSatisfied = (
  router: NextRouter,
  timeRange: TimeRangeSelector.TimeRange.Resolved,
  currentTheme: string,
  userInfo: UserInfoPayload | undefined,
  globalsInitialized: boolean,
) => router.isReady && !globalsInitialized && isValidTimeRange(timeRange) && isValidCurrentTheme(currentTheme);

export default arePreInitConditionsSatisfied;
